import React, {
    useRef,
    useState,
    useEffect,
    useImperativeHandle,
    forwardRef,
    ForwardedRef,
} from 'react';
import noop from 'lodash/noop';
import useMountedState from 'react-use/lib/useMountedState';
import { ImageProps } from './Image';
import { Img as ImgBase } from './styles';

export const Img = forwardRef((props: ImageProps, ref: ForwardedRef<HTMLImageElement | null>) => {
    const isMounted = useMountedState();
    const [isLoaded, setIsLoaded] = useState(false);
    const innerRef = useRef<HTMLImageElement | null>(null);

    useImperativeHandle<HTMLImageElement | null, HTMLImageElement | null>(
        ref,
        () => innerRef.current,
    );

    useEffect(() => {
        if (!innerRef.current) {
            return noop;
        }

        if (!innerRef.current.complete) {
            const onImageLoaded = () => {
                if (isMounted()) {
                    setIsLoaded(true);
                }
            };

            innerRef.current.addEventListener('load', onImageLoaded);
            innerRef.current.addEventListener('error', props.onError ?? noop);

            return () => {
                innerRef.current?.removeEventListener('load', onImageLoaded);
                // eslint-disable-next-line react-hooks/exhaustive-deps
                innerRef.current?.removeEventListener('error', props.onError ?? noop);
            };
        }

        setIsLoaded(true);

        return noop;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [innerRef.current]);

    return <ImgBase {...props} ref={innerRef} isLoaded={isLoaded} />;
});

Img.defaultProps = {
    objectFit: 'cover',
};
